import apiMachine from '@front/common/apiMachine'
import { createPromise } from '@front/common/utils'
import { assign } from 'xstate'
import { useMachine } from 'xstate-vue2'

export default (service) => {
  let createdPromise = createPromise()
  let onSuccessCallback = null

  const onSuccess = (callback) => {
    onSuccessCallback = async (data, request) => {
      callback(data, request)
    }
  }

  const { state, send } = useMachine(apiMachine, {
    actions: {
      notifySuccess: assign(({ data, request }) => {
        if (onSuccessCallback) {
          onSuccessCallback(data, request)
        }

        createdPromise.resolver(data, request)
        createdPromise = createPromise()
      }),
      notifyError: assign(({ error }) => {
        createdPromise.rejecter(error)
        createdPromise = createPromise()
      }),
    },
    services: {
      service: (context, { data } = {}) => {
        return service(...data)
      },
    },
  })

  return [
    onSuccess,
    state,
    (...data) => {
      send('SEND', { data })

      return createdPromise.promise
    },
  ]
}
